/**
 * The project plan: the milestones of a project and the work grouped under them, placed on a
 * calendar, with every number derived from records that already exist.
 *
 * Nothing here is stored as a plan of its own. The rows behind it are the project, its
 * milestones, their deliverables and the tasks that point at a milestone; the API reads them and
 * computes the rest, so no one has to remember to update a percentage.
 */
/** What the headline percentage was computed from. */
export const PROJECT_PROGRESS_BASIS = {
    /** Completed tasks ÷ tasks that are not cancelled. */
    TASKS: 'TASKS',
    /** The project has no task to count yet. */
    NONE: 'NONE',
};
export const PROJECT_PLAN_ITEM_KIND = {
    MILESTONE: 'MILESTONE',
    /** Work in the project that no milestone claims. Never shown to a client. */
    UNGROUPED: 'UNGROUPED',
};
//# sourceMappingURL=project-plan.js.map